import React from "react";
import {Form} from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";


// 톤수
const OPTIONS_FRQRANGE = [
  {range_code: "HF",    label: "HF"},
  {range_code: "VHF",   label: "VHF"},
  {range_code: "UHF",   label: "UHF"},
  {range_code: "OTHER", label: "기타"},
];


function WidgetAmateurStats() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="주파수대역"
        fieldName={"range_code_stats_list"}
        options={OPTIONS_FRQRANGE.map(({ range_code, label }) => ({
          value: range_code,
          label,
        }))}
        colSpan={6} />
    </Form.Item>
  );
}


export default WidgetAmateurStats;
